// extracted by mini-css-extract-plugin
export default {"notes":"NotesField_notes__-fqRs"};